//授课-课中 教学轨迹
export const SK_PORTRAYAL_TEACHING_TRACK = 'sk_portrayal_teaching_track'

//授课-课中 到课率
export const SK_PORTRAYAL_COURSE_RATIO = 'sk_portrayal_course_ratio'

//授课-课中 作业率
export const SK_PORTRAYAL_HOMEWORK_RATIO = 'sk_portrayal_homework_ratio'

//授课-课中 任务率
export const SK_PORTRAYAL_TASK_RATIO = 'sk_portrayal_task_ratio'

//授课-课中 测试率
export const SK_PORTRAYAL_TEST_RATIO = 'sk_portrayal_test_ratio'

//授课-课中 小组排名
export const SK_PORTRAYAL_GROUP_LIST = 'sk_portrayal_group_list'

//授课-课中 学生进步排名
export const SK_PORTRAYAL_STU_IMPROVE_LIST = 'sk_portrayal_stu_improve_list'

//授课-课中 学生活跃排名
export const SK_PORTRAYAL_STU_LIVELY_LIST = 'sk_portrayal_stu_lively_list'

//授课-课中 学生素质排名
export const SK_PORTRAYAL_STU_QUALITY_LIST = 'sk_portrayal_stu_quality_list'

//授课-课中 学生成绩排名
export const SK_PORTRAYAL_STU_ACHIEVEMENT_LIST = 'sk_portrayal_stu_achievement_list'

//授课-课中 活动参与率
export const SK_PORTRAYAL_ACTIVE_RATIO = 'sk_portrayal_active_ratio'



// WEBPACK FOOTER //
// ./src/store/give-course/portrayal/type.js